//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../no/Builder.js";
let d=[[[0,"CheckDependentExpressions",1,0],[0,"DatasetName",1,0],[0,"ExportOption",1,0],[0,"OperateOption",1,0],[0,"OverrideExistingExpressions",1,0],[0,"SpreadSheetFileName",1,0],[0,"SpreadsheetItemID",1,0],[0,"SpreadsheetItemName",1,0],[0,"SpreadsheetItemRevision",1,0]],[[["itemId","itemName","itemRevision","idSensitivity","revSensitivity"],"AssignItemNumber",{},0,0],[["itemId","itemRevision","revSensitivity"],"AssignItemRevision",{},1,0],[["objectCreateBuilder"],"SetObjectCreateBuilder",{},1,0]],[]];
SPLM.Features.VehicleDesign.BaseDataImportExportBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.BaseDataImportExportBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.BaseDataImportExportBuilder.OperateOptions = Object.freeze({
    "Import" : "Import", "Export" : "Export"});

SPLM.Features.VehicleDesign.BaseDataImportExportBuilder.ExportOptions = Object.freeze({
    "NewItem" : "NewItem", "ExistingItem" : "ExistingItem"});

export default SPLM;